import React, { Component } from 'react'
import { Button, Row, Form, Input } from 'antd'
import config from '../../utils/config'

const FormItem = Form.Item

class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {passwordDirty: false};
    }

    handleSubmit(e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            this.props.user.password = values.confirm
            this.props.onOk(this.props.user)
        })
    }

    handlePasswordBlur(e) {
        const value = e.target.value;
        this.setState({
            passwordDirty: this.state.passwordDirty || !!value
        });
    }

    checkPassword(rule, value, callback) {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('Las contraseñas no coinciden!');
        } else {
            callback();
        }
    }

    checkConfirm(rule, value, callback) {
        const form = this.props.form;
        if (value && this.state.passwordDirty) {
            form.validateFields(['confirm'], {force: true});
        }
        callback();
    }

    render() {
        const {getFieldDecorator} = this.props.form;

        return (
            <div className={"login-box-body portlet-body"}>
                <div className={"login-logo"}>
                    <img src={config.logoSrc} alt={config.logoText}/>
                </div>

                <p className={'text-center padding20'}>A continuación escriba su nueva contraseña para terminar el proceso de recuperación</p>

                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <FormItem hasFeedback>
                        {getFieldDecorator('password', {
                            rules: [{
                                required: true,
                                message: 'Por favor, ingrese mínimo 6 caracteres para su nueva contraseña',
                                min: 6
                            }, {
                                validator: this.checkConfirm.bind(this)
                            }]
                        })(<Input size='large' type='password' onBlur={this.handlePasswordBlur.bind(this)} onPressEnter={this.handleSubmit.bind(this)} placeholder='Nueva contraseña' />)}
                    </FormItem>

                    <FormItem hasFeedback>
                        {getFieldDecorator('confirm', {
                            rules: [{
                                required: true,
                                message: 'Por favor, vuelva a escribir su nueva contraseña',
                                min: 6
                            }, {
                                validator: this.checkPassword.bind(this)
                            }]
                        })(<Input size='large' type='password' onPressEnter={this.handleSubmit.bind(this)} placeholder='Confirmar contraseña' />)}
                    </FormItem>
                    
                    <Row className={'text-center paddingBottom20'}>
                        <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.buttonLoading} className={'btn btn-primary btn-flat'}>
                            Actualizar contraseña
                        </Button>
                    </Row>
                </Form>
            </div>
        );
    }
};

export default Form.create()(ResetPassword)


// WEBPACK FOOTER //
// ./src/components/authentication/resetPassword.js